module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Attachment#2-e2ca9f15054673248eb3a02731a03509.svg";